import { Stack, Tooltip, Typography } from '@mui/material';
import InputBase from '@mui/material/InputBase';
import { alpha, styled } from '@mui/material/styles';
import { isEmpty, trim } from 'lodash-es';
import PropTypes from 'prop-types';
import * as React from 'react';
import { MdInfo } from 'react-icons/md';
import ClickableTooltip from './ClickableTooltip';
import { cx } from 'cva';

// const StyledInputBase = styled(InputBase, {
//   shouldForwardProp: (prop) => !['width', 'InputProps', 'error'].includes(prop),
// })(({ theme, width, error }) => ({
//   width: width || 'auto',
//   '& .MuiInputAdornment-positionStart': {
//     position: 'absolute',
//     left: '8px',
//   },
//   '& .MuiInputBase-input': {
//     borderRadius: 20,
//     position: 'relative',
//     // backgroundColor: '#fcfcfb',
//     // border: '1px solid #ced4da',
//     boxShadow: 'inset 0px 1px 5px #d0d0d0',
//     border: `1px solid ${error ? theme.palette.warning.light : '#eaeaea'}`,
//     fontSize: 16,
//     width: width || 'auto',
//     // padding: '6px 16px',
//     padding: '10px 16px',
//     transition: theme.transitions.create([
//       'border-color',
//       //   'background-color',
//       'box-shadow',
//     ]),
//     '&:focus': {
//       boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
//       borderColor: theme.palette.primary.main,
//     },
//   },

//   '& .MuiInputBase-inputAdornedStart': {
//     paddingLeft: '24px',
//   },
//   '& .MuiInputAdornment-root.MuiInputAdornment-positionEnd': {
//     position: 'absolute',
//     right: '20px',
//   },
// }));


const StyledInputBase = styled(InputBase, {
  shouldForwardProp: (prop) => !['width', 'InputProps', 'error'].includes(prop),
})(({ theme, width, error }) => ({
  width: width || 'auto',
  '& .MuiInputAdornment-positionStart': {
    position: 'absolute',
    // left: '6px',
  },
  '& .MuiInputBase-input': {
    // borderRadius: 20,
    position: 'relative',
    // backgroundColor: '#fcfcfb',
    // border: '1px solid #ced4da',
    // boxShadow: 'inset 0px 1px 5px #d0d0d0',
    // border: `1px solid ${error ? theme.palette.warning.light : '#eaeaea'}`,
    // fontSize: 16,
    width: width || 'auto',
    // padding: '6px 16px',
    // padding: '5px 16px',
    transition: theme.transitions.create([
      // 'border-color',
      //   'background-color',
      // 'box-shadow',
    ]),
    '&:focus': {
      // boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
    //   borderColor: theme.palette.primary.main,
    },
  },

  '& .MuiInputBase-inputAdornedStart': {
    paddingLeft: '24px',
  },
  '& .MuiInputAdornment-root.MuiInputAdornment-positionEnd': {
    position: 'absolute',
    right: '20px',
  },
}));

function StyledInput(props) {
  const {
    placeholder = '',
    asLabel = true,
    tooltip = '',
    tooltipProps = {},
    register = {},
    errorMessage = '--hide--',
    required = false,
    InputProps = null,
    className = '',
    ...rest
  } = props;

  const showEndAdornment = !!(InputProps && InputProps.endAdornment);

  const { ref, ...registerProps } = register || { ref: null, ...{} };
  const hasError = !!errorMessage && errorMessage !== '--hide--';
  if (isEmpty(trim(placeholder)) || !asLabel) {
    return (
      <>
        <StyledInputBase
          id={registerProps.name || 'input'}
          inputRef={ref}
          {...registerProps}
          error={hasError}
          placeholder={placeholder}
          endAdornment={showEndAdornment ? InputProps.endAdornment : null}
          {...rest}
        />
        {errorMessage !== '--hide--' && (
          <Typography
            variant="caption"
            component="div"
            color={hasError ? 'error' : 'transparent'}
            ml="20px"
            mt="2px">
            {errorMessage || '-'}
          </Typography>
        )}
      </>
    );
  }

  return (
    <Stack width="100%">
      <Stack direction="row" spacing={0.5} alignItems="center" mb="4px">
        <Typography variant="body2" color="textSecondary" ml="20px">
          {required ? `${placeholder} *` : placeholder}
        </Typography>
        {tooltip && <ClickableTooltip message={tooltip} {...tooltipProps} />}
      </Stack>
      <StyledInputBase
        id={registerProps.name || 'input'}
        inputRef={ref}
        {...registerProps}
        error={hasError}
        {...rest}
        className={cx(
          'focus:shadow-outline w-full rounded-lg bg-primary-light-1 px-6 py-3 font-poppins text-14 text-text-primary focus:outline-none',
          hasError && 'border border-error',
          className,
        )}
        endAdornment={showEndAdornment ? InputProps.endAdornment : null}
      />
      {errorMessage !== '--hide--' && (
        <Typography
          variant="caption"
          color={hasError ? 'error' : 'transparent'}
          ml="20px"
          mt="2px">
          {errorMessage || '-'}
        </Typography>
      )}
    </Stack>
  );
}

StyledInput.propTypes = {
  placeholder: PropTypes.string,
  asLabel: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipProps: PropTypes.shape({
    placement: PropTypes.string,
  }),
  register: PropTypes.shape({
    ref: PropTypes.func,
  }),
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  InputProps: PropTypes.shape({
    endAdornment: PropTypes.node,
  }),
};

export default StyledInput;
